<template>
  <div v-if="school">
    <h1 class="text-uppercase">
        <img :src="school.logo" class="shrink mr-2" height="30"/>
        <span class="title font-weight-bold">
            {{school.name}}
        </span>
    </h1>
        <p class="caption font-weight-regular">
            {{school.motto}}
        </p>
  </div>
  <div v-else>
    <h1>
        &nbsp; <br>
        <span class="display-1 font-weight-bold">
            LESSON NOTES SPACE
        </span>
    </h1>
        <p class="subheading font-weight-regular">
            Manage Lesson Notes as a Teacher
        </p>
  </div>
</template>

<script>
export default {
    name: 'Header',
    data: () => ({
        school:localStorage.getItem('school') ? JSON.parse(localStorage.getItem('school')) : null,
    }),
}
</script>